import { render, staticRenderFns } from "./LayoutGroup.vue?vue&type=template&id=5e909554&scoped=true&"
import script from "./LayoutGroup.vue?vue&type=script&lang=js&"
export * from "./LayoutGroup.vue?vue&type=script&lang=js&"
import style0 from "./LayoutGroup.vue?vue&type=style&index=0&id=5e909554&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e909554",
  null
  
)

export default component.exports